import { fetchTicketNotifList } from './fetchTicketNotifList';
import { sendSumoLog } from './sumoLogger';
import { updateError } from '../../store';

export const deleteTicketNotif = async (token, notifId, dispatch) => {
  const requestUrl = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/notification/${notifId}`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'DELETE',
      headers,
    });

    if (!data.ok) {
      throw {
        message: `Failed To Delete Ticket Notif ${notifId}: ${data.status}`,
        code: data.status,
      };
    }

    fetchTicketNotifList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;
    sendSumoLog(
      'deleteTicketNotif',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );
    updateError(error, dispatch);
  }
};
